import address from 'plugins/i18n/entity/address.de.ts'
import unit from 'plugins/i18n/entity/unit.de.ts'

const building = {
	name: 'Liegenschaft | Liegenschaften',
	icon: 'fa-regular fa-building | fa-regular fa-buildings',
	fields: {
		hp_id: 'ID',
		address: {
			...address.fields,
		},
		building_type: {
			name: 'Typ',
		},
		document_container: {
			units: {
				...unit.fields,
			},
		},
		heating_type: 'Heizung',
		hotwater_type: 'Warmwasser',
		garage_type: 'Garage',
		trashbarrel_type: 'Müllgefäße',
		team: 'Team',
		year_of_construction: 'Baujahr',
		propertymanager_id: 'Hausverwaltung',
		propertymanager: {
			person: {
				lastname: 'Hausverwaltung',
			},
		},
		proposed_for_export: 'Aaremo-Freigabe',
	},
	tabs: {
		building: '@:common.information',
		documents: '@:entity.document.name',
		units: '@:entity.unit.name',
		persons: '@:entity.person.name',
		tasks: '@:entity.task.name',
		meters: '@:entity.meter.name',
		cis: '@:entity.cis.name',
		craftsman_tasks: '@:entity.craftsman_task.name',
		handoverprotocols: '@:entity.handoverProtocol.name',
		accounting: 'Buchhaltung',
	},
}

export default building
